import { useEffect } from "react";
import { Outlet, useParams } from "react-router";
import { setNPSToken } from "@/lib/npsToken";

// アンマウント時のクリアを次のタスクへ遅延させるためのタイマー ID (モジュール共有)。
// 遅延させる理由は ReservationTokenLayout と同じ (StrictMode の effect 二重実行対策)。
let pendingClearTimer: ReturnType<typeof setTimeout> | undefined;

/**
 * NPS アンケート画面 (/nps/:npsToken) 用のレイアウト。
 *
 * アンケートは来店確定後のアンケート依頼メールのリンクから開くため案件アクセストークンを持たず、
 * URL の npsToken だけが GetNPSContext / SubmitNPSAnswer の認可の根拠になる (§6.7)。
 * 子の useQuery が発火する前に interceptor が最新のトークンを参照できるよう、レンダー時点で
 * 同期的に反映する (ReservationTokenLayout と同方式。useEffect だと 1 tick 遅れのレースになる)。
 *
 * アンマウント時はトークンをクリアし、npsTokenInterceptor がアンケート画面を離れた後の RPC に
 * まで `x-nps-token` を付与し続けないようにする。ただし StrictMode の effect 二重実行
 * (setup → cleanup → setup) で cleanup だけが走ってトークンを失わないよう、クリアは次のタスクへ
 * 遅延させ、再マウント時の setup がそれをキャンセルする。
 * Header + Footer は親の AppLayout が付与する。
 */
export function NPSTokenLayout() {
  const { npsToken } = useParams<{ npsToken: string }>();
  setNPSToken(npsToken);

  useEffect(() => {
    if (pendingClearTimer !== undefined) {
      clearTimeout(pendingClearTimer);
      pendingClearTimer = undefined;
    }
    setNPSToken(npsToken);

    return () => {
      pendingClearTimer = setTimeout(() => {
        setNPSToken(undefined);
        pendingClearTimer = undefined;
      }, 0);
    };
  }, [npsToken]);

  return <Outlet />;
}
